<template>
    <div>
        <template v-if="locale === 'ru'">
            <div class="container welcome__container">
                <welcome-header/>

                <welcome-section
                    id="pages"
                    title="Страницы памяти"
                    text="Читайте страницы с интересными историями, а также создавайте страницы памяти для своих близких. Это лучший современный способ сохранить о них воспоминания"
                    project-link="/page"
                    text-width="583px"
                    num="01"
                    content-header
                    @refresh="getPages"
                >
                    <welcome-pages/>
                </welcome-section>

                <welcome-bot-info></welcome-bot-info>

                <welcome-section
                    id="memorial"
                    title="Памятные места"
                    text="Лучший инструмент для сохранения памяти и создания точек притяжения туристов, гостей и местных жителей в вашем городе."
                    project-link="/place"
                    text-width="420px"
                    num="02"
                    content-header
                    @refresh="getMemorial"
                >
                    <welcome-memorials/>
                </welcome-section>

                <welcome-section
                    id="tree"
                    title="Генеалогическое древо"
                    project-link="/familytree"
                    num="03"
                    custom-content
                >
                    <template #text>
                        <p class="welcome__tree-text">
                            {{ $lang('welcome.ft.romanov.desc') }}
                        </p>
                    </template>

                    <template #default>
                        <welcome-family-tree/>
                    </template>
                </welcome-section>
            </div>

            <welcome-excursions id="excursions" />

            <welcome-about-us/>
        </template>

        <welcome-registration/>
    </div>
</template>

<script>
import WelcomeHeader from "./WelcomeHeader.vue";
import WelcomeSection from "./WelcomeSection.vue";
import WelcomePages from "./WelcomePages.vue";
import WelcomeExcursions from "./WelcomeExcursions";
import WelcomeMemorials from "./WelcomeMemorials.vue";
import WelcomeFamilyTree from "./WelcomeFamilyTree.vue";
import {mapActions} from "vuex";
import WelcomeAboutUs from "./WelcomeAboutUs.vue";
import WelcomeRegistration from "./WelcomeRegistration.vue";
import WelcomeBotInfo from "./WelcomeBotInfo.vue";

export default {
    name: 'Welcome',
    components: {
        WelcomeRegistration,
        WelcomeAboutUs,
        WelcomeFamilyTree,
        WelcomeMemorials,
        WelcomeExcursions,
        WelcomePages,
        WelcomeSection,
        WelcomeHeader,
        WelcomeBotInfo,
    },
    data() {
        return {
            locale: window.laravel.locale
        };
    },
    methods: {
        ...mapActions('welcome', [
            'getPages',
            'getMemorial',
        ]),
    },

}
</script>

<style lang="scss" scoped>
.welcome__container {
    margin-top: 47px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    @media (max-width: 1159px) {
        margin-top: 31px;
    }
    @media (max-width: 560px) {
        margin-top: 29px;
    }
}
.welcome__tree-text {
    @media (min-width: 1160px) {
        margin-top: 39px;
        width: 421px;
    }
    @media (max-width: 1199px) {
        max-width: 571px;
    }
    @media (max-width: 360px) {
        max-width: 280px;
    }
}
</style>

<style lang="scss">
.header__row--bottom {
    @media (min-width: 1201px) {
        display: none;
    }
}
</style>
